(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("LearningItemEditOnlineExamModalCtrl", ["examResource", "examQuestionResource", "tenantExamMessagesResource", "learningItemOnlineExamResource", "messageService", "$scope", "$translate", "learningItemOnlineExam", "typeId", "DTOptionsBuilder", "DTColumnDefBuilder", "EXAMDETAIL_STATUS", "_", learningItemEditOnlineExamModalCtrl]);
    function learningItemEditOnlineExamModalCtrl(examResource, examQuestionResource, tenantExamMessagesResource, learningItemOnlineExamResource, messageService, $scope, $translate, learningItemOnlineExam, typeId, DTOptionsBuilder, DTColumnDefBuilder, EXAMDETAIL_STATUS, _) {
        var vm = this;
        vm.typeId = typeId;
        vm.form = learningItemOnlineExam;
        vm.form.examId = learningItemOnlineExam.exam.id;
        vm.examSelectOpen = false;
        tenantExamMessagesResource.get({ localizationId: vm.form.localizationId }, function (model) {
            vm.failMessages = _.filter(model.tenantExamMessages, function (item) { return item.type === "Fail"; });
            vm.passMessages = _.filter(model.tenantExamMessages, function (item) { return item.type === "Pass"; });
            if (vm.form.id !== null) {
                var passMessageObj = _.find(vm.passMessages, { id: vm.form.passMessageId });
                vm.form.activePassMessage = vm.passMessages.indexOf(passMessageObj);
                var failMessageObj = _.find(vm.failMessages, { id: vm.form.failMessageId });
                vm.form.activeFailMessage = vm.failMessages.indexOf(failMessageObj);
            }
        });
        //Initialize the ng-models
        //vm.allowedAttempts = _.range(1, 21);
        if (vm.form.id === null) {
            vm.form.proctorTypeId = 0;
            vm.form.showExamDetailId = EXAMDETAIL_STATUS.Disabled;
            vm.form.requiresPassword = false;
            vm.form.timed = true;
            vm.form.timeLimit = 30;
            vm.form.passingScore = 80;
            vm.form.numberOfAttempts = 5;
            vm.form.unlimitedAttempts = false;
            vm.form.activePassMessage = 0;
            vm.form.activeFailMessage = 0;
            vm.form.initialized = true;
            vm.form.exam = null;
        }
        //Exam Selection
        vm.dataLoaded = false;
        vm.questionsLoaded = false;
        vm.dtInstance = {};
        vm.dtSearch = "";
        vm.model = {
            exams: []
        };
        vm.questionsView = false;
        vm.examQuestions = [];
        vm.lang = $translate.proposedLanguage() || $translate.use();
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
            .withOption("processing", false)
            .withOption("responsive", { details: { type: "column" } })
            .withOption("stateSave", false)
            .withOption("stateDuration", -1)
            .withOption("order", [1, "asc"])
            .withPaginationType("full_numbers")
            .withOption("rowCallback", rowCallback)
            .withBootstrap();
        examResource.getExamSelectionModalExamsViewModal({ localizationId: vm.form.localizationId }, function (model) {
            vm.model = model;
            vm.dataLoaded = true;
        });
        vm.rowClickHandler = rowClickHandler;
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).withOption("class", "control").withOption("sortable", false).withOption("targets", 0)
        ];
        function rowClickHandler(row, data) {
            var selectedExam = { name: data[2], id: row.id };
            vm.form.exam = selectedExam;
            vm.form.examName = selectedExam.name;
            vm.form.examId = selectedExam.id;
            vm.examSelectOpen = false;
        }
        function rowCallback(nRow, aData) {
            // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
            $("td:not(.control)", nRow).unbind("click");
            $("td:not(.control)", nRow).bind("click", function () {
                $scope.$apply(function () {
                    rowClickHandler(nRow, aData);
                });
            });
            return nRow;
        }
        vm.dtOptionsQuestions = DTOptionsBuilder.newOptions()
            .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
            .withOption("processing", false)
            .withOption("responsive", { details: { type: "column" } })
            .withOption("stateSave", false)
            .withOption("stateDuration", -1)
            .withOption("order", [0, "asc"])
            .withPaginationType("full_numbers")
            .withBootstrap();
        vm.goToQuestions = function (number) {
            vm.questionsView = true;
            vm.examSelectOpen = false;
            examQuestionResource.getExamSelectionModalQuestionsViewModel({ number: number }, function (model) {
                vm.examQuestions = model.questions;
                vm.questionsLoaded = true;
            });
        };
        vm.search = function () {
            vm.dtInstance.DataTable.search(vm.dtSearch).draw();
        };
        vm.backToDetails = function () {
            vm.questionsView = false;
            vm.examSelectOpen = false;
        };
        vm.backExamSelection = function () {
            vm.questionsView = false;
            vm.examSelectOpen = true;
            vm.examQuestions = [];
        };
        vm.setFailedMessageId = function (nextSlide) {
            vm.form.failMessageId = vm.failMessages[nextSlide.slide.index].id;
        };
        vm.setPassedMessageId = function (nextSlide) {
            vm.form.passMessageId = vm.passMessages[nextSlide.slide.index].id;
        };
        //vm.getNumberOfAttemptsInitValue = function () {
        //	return vm.form.numberOfAttempts ? vm.form.numberOfAttempts : 5;
        //};
        vm.openExamSelect = function () {
            vm.examSelectOpen = true;
        };
        vm.updateLearningItemOnlineExam = function (isValid) {
            if (isValid) {
                if (learningItemOnlineExam.id > 0) {
                    learningItemOnlineExamResource.update(learningItemOnlineExam, function (result) {
                        learningItemOnlineExam = result;
                        messageService.success("learningItem.updatedSuccessMessage");
                        $scope.$close(result);
                    }, function (error) {
                        messageService.error(error);
                    });
                }
                else {
                    learningItemOnlineExamResource.save(learningItemOnlineExam, function (result) {
                        learningItemOnlineExam = result;
                        messageService.success("learningItem.updatedSuccessMessage");
                        $scope.$close(result);
                    }, function (error) {
                        messageService.error(error);
                    });
                }
            }
            else {
                vm.showErrors = true;
            }
        };
    }
}());
